module.exports = __webpack_public_path__ + "static/media/testimonal-card.cb5e97b6.JPG";